import React from 'react'
import StatusBarChart from './StatusBarChart'

const InvoiceOvertimeGraph = () => {
  return (
      <div class="col-md-4 col-12 mb-2 pb-1">
          <div class="card mb-0 border-0 shadow-none h-100">
              <div class="card-header sh_accordionheader">
                  <div class="d-flex justify-content-between align-items-center">
                      <h6 class="text-md font-weight-bold mb-0">Invoice Overtime </h6>
                      <div>
                          <a class="btn btn-light sh_btnlight">View Report</a>
                      </div>
                  </div>
              </div>
              <div class="card-body px-0 py-1">
                  <div class="sh_dashchartcontainer h-100">
                    <StatusBarChart />
                      {/* <canvas id="barChartCanvas" style={{ display: 'block', boxSizing: 'border-box', height: 227, width: 174 }} width="174" height="227"></canvas> */}
                  </div>
              </div>
          </div>
      </div>
  )
}

export default InvoiceOvertimeGraph